import { useMap } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'
import { useAppSelector } from '../store/hooks'
import MarkerWithPopup from '../../../../assets/frontend/js/components/location-map/MarkerWithPopup'
import type { MarkerItem } from '../../../../assets/frontend/js/components/location-map/types'
import type { LocationUrlConfig } from '../../../../assets/frontend/js/components/location-map/urlUtils'

const MIN_ZOOM_FOR_MARKERS = 5

export default function LocationsMapMarkers() {
  const config = useAppSelector((state) => state.config)
  const map = useMap()
  const [zoom, setZoom] = useState<number | null>(0)
  const [selectedId, setSelectedId] = useState<string | null>(null)

  const urlConfig: LocationUrlConfig = {
    redirectBaseUrl: config.redirectBaseUrl,
    microchurchSlug: config.microchurchSlug
  }

  useEffect(() => {
    if (!map) return

    setZoom(map.getZoom() ?? 0)
    const listener = map.addListener('zoom_changed', () => {
      setZoom(map.getZoom() ?? 0)
    })

    return () => {
      google.maps.event.removeListener(listener)
    }
  }, [map])

  // Close popup when clicking on map
  useEffect(() => {
    if (!map) return

    const listener = map.addListener('click', () => {
      setSelectedId(null)
    })

    return () => {
      google.maps.event.removeListener(listener)
    }
  }, [map])

  const items: MarkerItem[] = config.locations?.map((location) => ({
    objectID: location.organizationSlug ? location.organizationSlug + "-" + location.slug : location.slug,
    _geoloc: {
      lat: location.place.latitude,
      lng: location.place.longitude
    },
    ...location
  })) || []

  if (zoom === null || zoom < MIN_ZOOM_FOR_MARKERS) {
    return null
  }

  return (
    <>
      {items.map((item) => (
        <MarkerWithPopup
          key={item.objectID}
          item={item}
          isSelected={selectedId === item.objectID}
          onSelect={() => setSelectedId(item.objectID)}
          onClose={() => setSelectedId(null)}
          urlConfig={urlConfig}
        />
      ))}
    </>
  )
}
